<template>
  <div class="el-tabs__inner">
    <draggable
      :list="fields"
      :clone="clone"
      class="row justify-center ma-0"
      :group="{
        name:
          isForm == 'forms-expression'
            ? activeFieldExpression.key
            : 'FormSentence',
        pull: 'clone',
        put: false,
      }"
      :sort="false"
      :move="onMove"
    >
      <template v-for="(field, index) in fields">
        <!-- Form Elements for Title -->
        <template v-if="checkElementTitle(field)">
          <v-col class :key="index">
            <span
              class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold"
              >{{ $t(field.text) }}</span
            >
          </v-col>
        </template>
        <!-- Form Elements for Example -->
        <template v-else-if="checkElementExample(field)">
          <v-col class :key="index">
            <span
              class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold"
              >{{ $t(field.text) }}</span
            >
          </v-col>
        </template>
        <!-- Form Elements for sentence -->
        <template v-else-if="checkElementSentence(field)">
          <v-col class :key="index">
            <span
              class="badge button__sidebar v-btn v-btn--contained theme--light v-size--default font-weight-bold"
              >{{ $t(field.text) }}</span
            >
          </v-col>
        </template>
      </template>
    </draggable>
  </div>
</template>


<script>
import { FormBuilder } from "@/components/form_elements_sentences/formbuilderElements";
// import draggable from "vuedraggable";
export default {
  name: "Elements",
  components: FormBuilder.$options.components,
  store: ["activeFieldExpression", "isForm"],
  data() {
    return {
      fields: FormBuilder.$data.fields,
    };
  },
  methods: {
    clone(field) {
      return this._.cloneDeep(field);
    },
    cloneElement(index, field, form, fieldsDefaultID) {
      var cloned = this._.cloneDeep(field); // clone deep lodash
      cloned.id = `${fieldsDefaultID}`;
      form.splice(index + 1, 0, cloned);
      this.editElementProperties(cloned);
    },

    editElementProperties(field) {
      this.$store.activeFieldExpression = field;
      this.$store.activeTabForFieldsExpression = "properties";
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    checkElementExample(field) {
      const { activeFieldExpression } = this;
      let res =
        activeFieldExpression.key == "FormExample" &&
        (field.key == "Example" || field.key == "Illustration");

      return Boolean(res);
    },
    checkElementSentence(field) {
      let res =
        this.isForm != "forms-expression" &&
        (field.key == "Illustration" ||
          field.key == "Structure" ||
          field.key == "Challenge");
      return Boolean(res);
    },
    checkElementTitle(field) {
      const { activeFieldExpression } = this;
      let res =
        activeFieldExpression.key == "FormTitle" &&
        (field.key == "Title" ||
          field.key == "Explain" ||
          field.key == "Illustration");
      return Boolean(res);
    },
  },
};
</script>

<style lang="scss" scoped>
.button__sidebar {
  width: 100%;
  //   margin-bottom: 5px;

  .is-disabled & {
    opacity: 0.4;
  }
}

// Display this ghost in <main> only
.sortable__ghost {
  position: relative;
  max-width: 140px;
  //   border-bottom: 2px solid #3a8ee6;
  margin-top: -10px;
  //   margin-bottom: 2px;

  [type="button"] {
    display: none;
  }

  &:before {
    // content: "Drag it here";
    background-color: #ecf5ff;
    // color: #3a8ee6;
    position: absolute;
    // left: 50%;
    font-size: 10px;
    border-radius: 10px;
    // line-height: 15px;
    // padding: 0 10px;
    // top: -6px;
    transform: translateX(-50%);
  }
}
.pointer {
  cursor: pointer;
}
</style>
